App.controller('ZochHealthPzuwWithdrawalCtrl', ['$scope', '$sce', '$state', '$stateParams', '$filter', 'zochaPzuwHealthInsuranceService', 'popUpService', function ($scope, $sce, $state, $stateParams, $filter, zochaPzuwHealthInsuranceService, popUpService) {
    $scope.stateParams = $stateParams;

    $scope.page = 'zoch_healthInsurance';
    $scope.$emit('page', $scope.page);

    $scope.step = 'Wystąpienie'; 
    $scope.$emit('step', $scope.step);

    $scope.link = 'root.home.zoch.healthPzuw.list';
    $scope.$emit('link', $scope.link);

    if (!$scope.stateParams.declaration) {
        $state.go('root.home.zoch.healthPzuw.list');
    }

    $scope.maxDate = new Date();
    let firstDayOfMonth = new Date()
    firstDayOfMonth.setDate(1);
    $scope.minDate = firstDayOfMonth;
    $scope.dateOfDeath = new Date();
    $scope.declaration = $scope.stateParams.declaration;
    $scope.reason = 'EMPLOYEE_RESIGNATION';

    if ($scope.declaration.status === 'WITHDRAWN') {
        $scope.reason = $scope.declaration.withdrawalReason;
        $scope.dateOfDeath = $scope.declaration.dateOfDeath;
    }

    $scope.withdraw = function() {
        let vm = this;

        if (!vm.form.$valid) {
            return 0;
        }

        let criteria = {
            uuid: $scope.stateParams.declaration.uuid,
            data: {
                reason: $scope.reason
            }
        };

        if ($scope.reason === 'DEATH') {
            criteria.data.dateOfDeath = $filter('getDateFromBirthdate')($scope.dateOfDeath);
        }

        zochaPzuwHealthInsuranceService.withdrawDeclaration(criteria).then(function (data) {
            if (data.status === 200) {
                popUpService.showPopUp({
                    ev: '',
                    head: 'Wystąpienie oznaczone',
                    content: 'Wystąpienie zostało zapisane.',
                    text: 'Przejdź do listy deklaracji',
                    target: 'root.home.zoch.healthPzuw.list({"user": null})',
                    tpl: 'info-big'
                });
            } else {
                popUpService.showPopUpWithError(data.data, {
                    ev: '',
                    head: 'Wystąpienie nie zostało oznaczone',
                    content: 'Nie udało się zapisać wystąpienia.',
                    text: '',
                    target: ''
                });
            }
        });
    };
}]);
